/**
 * @file DialogCrear.js
 * @brief Componente para crear una especialidad donde se solicita el nombre de la especialidad y la cantidad de consultas
 * @requires React
 */

import React, { useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Box, MenuItem } from '@mui/material';
import { useFormik } from 'formik';

const DialogEditarConfiguracion = ({ open, handleClose, handleCrear, municipios, configuraciones, isEdit }) => {
  const formik = useFormik({
    initialValues: {
      municipio: '',
      casillasSignosVitales: '',
      casillasTriage: '',
      fecha: '',
    },
    onSubmit: (values) => {
      handleCrear(values);
    },
  });

  const actualizarFormik = (configuraciones) => {
    formik.setValues({
      municipio: configuraciones.find(c => c.nombre === 'Municipio')?.valor,
      casillasSignosVitales: configuraciones.find(c => c.nombre === 'Signos')?.valor,
      casillasTriage: configuraciones.find(c => c.nombre === 'Triage')?.valor,
      fecha: configuraciones.find(c => c.nombre === 'Fecha Evento')?.valor,
    });
  }

  useEffect(() => {
    isEdit && actualizarFormik(configuraciones);
    !isEdit && formik.resetForm();
    // eslint-disable-next-line
  }, [isEdit]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          width: '100%',
          backgroundColor: 'white',
          borderRadius: '10px',
        }
      }}
    >
      <DialogTitle>{isEdit ? 'Editar' : 'Crear'} brigada</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
            py: '1rem',
          }}
        >
          <TextField
            label='Municipio'
            name='municipio'
            variant='outlined'
            value={formik.values.municipio}
            onChange={formik.handleChange}
            error={formik.touched.municipio && Boolean(formik.errors.municipio)}
            helperText={formik.touched.municipio && formik.errors.municipio}
            onBlur={formik.handleBlur}
            select
          >
            {
              municipios?.map((rol) => (
                <MenuItem key={rol.id} value={rol.id}>
                  {rol.nombre}
                </MenuItem>
              ))
            }
          </TextField>
          <TextField
            label='Casillas Signos Vitales'
            name='casillasSignosVitales'
            variant='outlined'
            type='number'
            value={formik.values.casillasSignosVitales}
            onChange={formik.handleChange}
            error={formik.touched.casillasSignosVitales && Boolean(formik.errors.casillasSignosVitales)}
            helperText={formik.touched.casillasSignosVitales && formik.errors.casillasSignosVitales}
            onBlur={formik.handleBlur}
          />
          <TextField
            label='Casillas Triage'
            name='casillasTriage'
            variant='outlined'
            type='number'
            value={formik.values.casillasTriage}
            onChange={formik.handleChange}
            error={formik.touched.casillasTriage && Boolean(formik.errors.casillasTriage)}
            helperText={formik.touched.casillasTriage && formik.errors.casillasTriage}
            onBlur={formik.handleBlur}
          />
          <TextField
            label='Fecha'
            name='fecha'
            variant='outlined'
            type='date'
            value={formik.values.fecha}
            onChange={formik.handleChange}
            error={formik.touched.fecha && Boolean(formik.errors.fecha)}
            helperText={formik.touched.fecha && formik.errors.fecha}
            onBlur={formik.handleBlur}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
        >
          Cancelar
        </Button>
        <Button
          variant='contained'
          color='primary'
          type='submit'
          onClick={formik.handleSubmit}
        >
          {isEdit ? 'Editar brigada' : 'Crear brigada'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DialogEditarConfiguracion;